import { Component, OnInit, ViewChild, ElementRef, Inject, Renderer2, HostListener } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { Observable, forkJoin, fromEvent } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ClientaddressesService } from 'src/app/services/apiclient/clientaddresses/clientaddresses.service';
import { CitiesService } from 'src/app/services/apiclient/cities/cities.service';
import { CountriesService } from 'src/app/services/apiclient/countries/countries.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { startWith, tap, debounceTime, switchMap, filter, first } from 'rxjs/operators';
import { ValidatorsService } from 'src/app/services/validators/validators.service';

import * as moment from 'moment';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};
@Component({
  selector: 'app-required-informations',
  templateUrl: './required-informations.component.html',
  styleUrls: ['./required-informations.component.css'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },

  ]
})
export class RequiredInformationsComponent implements OnInit {

  @ViewChild('autoCompleteCountry', { read: MatAutocompleteTrigger, static: true }) acCountry: MatAutocompleteTrigger|any;
  @ViewChild('autoCompletePostal', { read: MatAutocompleteTrigger, static: true }) acPostal: MatAutocompleteTrigger|any;
  @ViewChild('autoCompletePostal', { read: ElementRef, static: true }) inputPostal: ElementRef|any;
  @ViewChild('selectCities', { read: MatSelect, static: true }) inputCities: MatSelect|any;

  eventHeight: Observable<any> = fromEvent(window, "resize");
  innerHeight: number = window.innerHeight;

  // Form data
  countries: any;
  postals: any;
  cities: any;
  requiredInfosForm: FormGroup|any;

  filteredCountries: Observable<any>|any;
  filteredPostals: Observable<any>|any;
  filteredCities: Observable<any>|any;

  loaders: any = {
    countries: false,
    postals: false,
    cities: false,
    page: true
  }

  unavailablePostal: boolean = false;

  errorMessage: string|any;

  client: any;

  addresses: any[];


  //birth
  minDate: moment.Moment = moment(new Date("01/01/1900"));
  maxDate: moment.Moment = moment(new Date("01/01/2100"));

  constructor(
    @Inject(MAT_DIALOG_DATA) data:any,
    public dialogRef: MatDialogRef<RequiredInformationsComponent>,
    private formBuilder: FormBuilder,
    private cityApi: CitiesService,
    private apiAddress: ClientaddressesService,
    private countriesApi: CountriesService,
    private vs: ValidatorsService,
    private authFb: AuthService,
    private tools: ToolsService,
    public translate: TranslateService

  ) {
    this.client = data.client;
    this.addresses = data.addresses
  }

  ngOnInit() {

    this.onWindowResize();
    this.createForm();

    this.countriesApi.getCountries().subscribe(countries => {

      this.countries = countries;

      this.requiredInfosForm.controls['id_country'].setValue(countries[0].id);
      this.requiredInfosForm.controls['country_name'].setValue(countries[0].name);

      this.getCountriesOnChange();
      this.getPostalsOnChange();

      this.checkUser();

      (this.addresses.length > 0) ? this.checkAddresses(this.addresses) : this.loaders.page = false;


    });

  }

  checkUser(): void {
    if (this.client.firstname || this.client.lastname || this.client.phone) {
      this.setUser(this.client, "api");
    } else {
      this.authFb.getUser.subscribe(user => {
        this.setUser(user, "fb");
      });
    }


    if (this.client.birth) { this.requiredInfosForm.get("birth").setValue(this.client.birth); };
    if (this.client.enable_marketing) { this.requiredInfosForm.get("enable_marketing").setValue(this.client.enable_marketing); };

  }

  checkAddresses(addresses: any[]): void {
    const defaultAddress = addresses.filter(add => add.is_default === 1);
    this.setAddress(defaultAddress[0]);
  }

  setUser(user: any, from: string): void {
    const splitedName = (from === "fb") && user.displayName ? user.displayName.split(' ') : [user.firstname, user.lastname];
    const phone = (from === "fb") ? user.phoneNumber : user.phone;
    this.requiredInfosForm.controls['firstname'].setValue(splitedName[0]);
    this.requiredInfosForm.controls['lastname'].setValue(splitedName[1]);
    this.requiredInfosForm.controls['phone'].setValue(phone);



    if (phone) {
      this.requiredInfosForm.controls['phone'].disable();
    }

  }

  setAddress(address: any): void {

    this.loaders.page = true;

    forkJoin(
      this.cityApi.getCities(address.id_country, address.postal),
      this.cityApi.getPostals(address.id_country, address.postal)
    ).subscribe(([cities, postals]) => {

      this.filteredCountries = this.filterCountries(address.country_name);
      this.filteredCities = cities;
      setTimeout(() => {
        this.filteredPostals = postals;
      }, 200);

      this.requiredInfosForm.controls['address'].setValue(address.address);
      this.requiredInfosForm.controls['postal'].setValue(address.postal);
      this.requiredInfosForm.controls['city_name'].setValue(address.city_name);
      this.requiredInfosForm.controls['country_name'].setValue(address.country_name);
      this.requiredInfosForm.controls['id_country'].setValue(address.id_country);
      this.requiredInfosForm.controls['id_city'].setValue(address.id_city);
      this.requiredInfosForm.controls['address_id'].setValue(address.address_id);

      this.loaders.page = false;

    });

  }

  createForm(): void {
    this.requiredInfosForm = this.formBuilder.group({
      firstname: ['', [Validators.required, this.vs.noSpaceValidator]],
      lastname: ['', [Validators.required, this.vs.noSpaceValidator]],
      phone: ['', [Validators.required, Validators.pattern('[^a-zA-Z]{1,}')]],
      address: ['', [Validators.required, this.vs.noSpaceValidator]],
      postal: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
      city_name: ['', [Validators.required]],
      country_name: ['', [Validators.required]],
      id_country: '',
      id_city: '',
      professional: [0],
      name: ["Défaut"],
      address_id: '',
      is_default: 1,
      birth: '',
      // birth:  ['', [Validators.required, this.vs.noSpaceValidator]],
      enable_marketing: ''
    });
  }

  initFormDatas(): void {
  }

  isFieldrequired(field: string): any {
    const thisField = this.requiredInfosForm.controls[field];
    if (thisField.errors) {
      if (thisField.errors.required) {
        return true;
      }
    }
  }

  submitRequiredInfos(): void {
    this.errorMessage = "";
    this.loaders.page = true;

    this.updateClient();

    const request = (this.addresses.length > 0) ? this.apiAddress.updateAddress(this.requiredInfosForm.value, "requiredInfos") : this.apiAddress.createAddress(this.requiredInfosForm.value, "requiredInfos");

    request.subscribe(

      data => {

        if (data.code === 0) {

          this.dialogRef.close(data);
          this.tools.openSnackBar(this.translate.instant('infoSaved'), "great");

        } else {

          this.errorMessage = data.message;

        }

        this.loaders.page = false;
      }

    )
  }

  // OnSelectOption (AutoComplete)

  onSelectCountry(country: any): void {
    this.requiredInfosForm.get("country_name").setValue(country.name, { emitEvent: false });
    this.requiredInfosForm.get("id_country").setValue(country.id, { emitEvent: false });
    this.removePostal();
    this.acCountry.closePanel();
    this.inputPostal.nativeElement.focus();
  }

  onSelectPostal(postal: any): void {

    this.requiredInfosForm.get("postal").setValue(postal, { emitEvent: false });
    this.removeCity();
    this.loaders.cities = true;

    this.cityApi.getCities(this.requiredInfosForm.get("id_country").value, postal).then(cities => {

      if (cities.length > 0) {

        this.filteredCities = cities;

        if (cities.length === 1) {
          this.requiredInfosForm.get("city_name").setValue(cities[0].name);

        }

        setTimeout(() => {
          this.inputCities.focus();
          if (cities.length > 1) { this.inputCities.toggle(); }
        });

      }

      this.loaders.cities = false;

    });

  }

  onSelectCity(city: any) {
    this.requiredInfosForm.get("id_city").setValue(city.id);
  }

  onChkChange(value: any) {
    this.requiredInfosForm.get("enable_marketing").setValue(value.checked);
    }

  // OnValueInputchange (AutoComplete) 

  getCountriesOnChange(): void {

    this.requiredInfosForm.get("country_name").valueChanges
      .pipe(
        startWith(''),
        tap(() => {

          this.loaders.countries = true;

        })
      )
      .subscribe((value:any) => {

        const filteredValueResults = this.filterCountries(value);

        if (value) {

          this.filteredCountries = (filteredValueResults.length > 0) ? filteredValueResults : null;
        } else {

          this.filteredCountries = this.countries.slice();

        }

        this.loaders.countries = false;

      });
  }

  getPostalsOnChange(): void {
    const countriesInput = this.requiredInfosForm.get("id_country");
    this.requiredInfosForm.get("postal").valueChanges
      .pipe(
        filter((v:any) => v && v.length > 3),
        debounceTime(200),
        tap(() => {
          this.loaders.postals = true;
        }),
        switchMap((value:any) => this.cityApi.getPostals(countriesInput.value, value))
      ).subscribe((postals:any) => {

        this.filteredPostals = (postals.length > 0) ? postals : null;

        if (this.filteredPostals) {

          this.onSelectPostal(this.filteredPostals[0]);
          this.unavailablePostal = false;

        } else {

          this.unavailablePostal = true;
          this.removeCity();

        }

        this.loaders.postals = false;

      });
  }

  // Filters (AutoComplete)

  filterCountries(value: string): any {
    const filterValue = value.toLowerCase();
    return this.countries.filter((country: any) => country.name.toLowerCase().indexOf(filterValue) === 0);
  }

  onTabKey() {
    if (this.filteredPostals) {
      this.requiredInfosForm.get('postal').setValue(this.filteredPostals[0]);
      this.onSelectPostal(this.filteredPostals[0]);
    }
  }

  onWindowResize() {
    this.eventHeight.subscribe(event => {
      this.innerHeight = event.target.innerHeight;
    });
  }


  removePostal() {
    this.filteredPostals = null;
    this.requiredInfosForm.get("postal").reset();
    this.requiredInfosForm.get("postal").setValue("");
    this.removeCity();
  }

  removeCity() {
    this.filteredCities = null;
    this.requiredInfosForm.get("id_city").reset();
    this.requiredInfosForm.get("city_name").reset();
    this.requiredInfosForm.get("id_city").setValue("");
    this.requiredInfosForm.get("city_name").setValue("");
  }





  /**
    * @description update client enable marketing birth
    * @return {void}
    */
  updateClient() {
    let toSend = {
      birth: moment(this.requiredInfosForm.value.birth).format('YYYY-MM-DD'),
      enable_marketing: this.requiredInfosForm.value.enable_marketing ? 1 : 0
    };

    this.authFb.updateClient(toSend, " ").then((data) => { });

  }


  /**
   * @description Déconnecte l'utilisateur connecté
   * @return {void}
   */
  logOut() {
    this.authFb.logOut("auth/home");
    this.dialogRef.close();
  }



}
